import Vue from 'vue';
import Router from 'vue-router';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Dashboard from '../views/Dashboard.vue';
import Shipping from '../views/Shipping.vue';
import ShippingList from '@/views/ShippingList.vue';

import ShippingLocalEmergency from '@/views/ShippingLocalEmergency.vue';
import ShippingLocalList from '@/views/ShippingLocalList.vue';
import ShippingLocalDocumentList from '@/views/ShippingLocalDocumentList.vue';
import ShippingLocalDocumentEmergency from '@/views/ShippingLocalDocumentEmergency.vue';

import Layout from '../components/Layout.vue';
import NotFound from '@/views/NotFound.vue';
import Company from '@/views/Company.vue';


import ShippingDocument from '../views/ShippingDocument.vue';
import ShippingDocumentList from '@/views/ShippingDocumentList.vue';

import Flota from '@/views/Flota.vue';
import Programacion from '@/views/Programacion.vue';
import ProgramacionDocumentos from '@/views/ProgramacionDocumentos.vue';
import DatosAgente from '@/views/DatosAgente.vue';
import GestionDocumentos from '@/views/GestionDocumentos.vue';
import Tracking from '@/views/Tracking.vue';
import TrackingLocal from '@/views/TrackingLocal.vue';
import Cotizador from '@/views/Cotizador.vue';
import ShippingLocal from '@/components/ShippingLocal.vue';
import ShippingLocalDocument from '@/components/ShippingLocalDocument.vue';
import DatosPersonal from '@/views/DatosPersonal.vue';
import GestionCostoAereo from '@/views/GestionCostoAereo.vue';
import GestionCostoTerrestre from '@/views/GestionCostoTerrestre.vue';
import GestionCostoExclusivo from '@/views/GestionCostoExclusivo.vue';
import GestionMetodoEnvio from '@/views/GestionMetodoEnvio.vue';
import GestionTiposUnidades from '@/views/GestionTiposUnidades.vue';
import GestionVehiculos from '@/views/GestionVehiculos.vue';
import GestionUsuarios from '@/views/GestionUsuarios.vue';
import Auditoria from '@/views/Auditoria.vue';

Vue.use(Router);

export default new Router({
    mode: 'history', // Evita el uso del símbolo #
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login
        },        
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/',
            component: Layout,  // Usamos el Layout que contiene el menú
            children: [
                {
                    path: '',
                    redirect: 'dashboard' // Redirige automáticamente a /dashboard
                },
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'cotizador',
                    name: 'Cotizador',
                    component: Cotizador
                },
                {
                    path: 'envios/:tipo_envio',
                    name: 'Shipping',
                    component: Shipping
                },
                {
                    path: 'editar-envio/:id',
                    name: 'shipping-edit',
                    component: Shipping
                },
                {
                    path: 'editar-envio-documento/:id',
                    name: 'shipping-document-edit',
                    component: ShippingDocument
                },
                {
                    path: 'editar-envio-local/:id',
                    name: 'shipping-edit',
                    component: ShippingLocal
                },
                {
                    path: 'editar-envio-local-documento/:id',
                    name: 'shipping-document-edit',
                    component: ShippingLocalDocument
                },  
                {
                    path: 'listado-envios/documentos',
                    name: 'ShippingList',
                    component: ShippingDocumentList
                },
                {
                    path: 'listado-envios/mercaderia',
                    name: 'ShippingList',
                    component: ShippingList
                },
                {
                    path: 'envios-documentos/:tipo_envio',
                    name: 'Documentos',
                    component: ShippingDocument
                },
                
                {
                    path: 'listado-envios-documentos/:tipo_envio',
                    name: 'ShippingDocumentList',
                    component: ShippingDocumentList
                },
                
                {
                    path: 'envios-locales-emergencias',
                    name: 'ShippingLocalEmergency',
                    component: ShippingLocalEmergency
                },                
                {
                    path: 'envios-locales-documentos-emergencias',
                    name: 'ShippingLocalDocEmergency',
                    component: ShippingLocalDocumentEmergency
                },

                {
                    path: 'listado-envios-documentos-locales',
                    name: 'ShippingLocalDocumentList',
                    component: ShippingLocalDocumentList
                },
                {
                    path: 'listado-envios-locales',
                    name: 'ShippingLocalList',
                    component: ShippingLocalList
                },

                 {
                    path: 'listado-envios-provincia',
                    name: 'ShippingList',
                    component: ShippingList
                },
                
                {
                    path: 'company',
                    name: 'Company',
                    component: Company
                },
                {
                    path: 'flota',
                    name: 'Flota',
                    component: Flota
                },{
                    path: 'programacion',
                    name: 'Programacion',
                    component: Programacion
                },{
                    path: 'programacion-documentos',
                    name: 'Programacion-documentos',
                    component: ProgramacionDocumentos
                },{
                    path: 'datos-agente',
                    name: 'DatosAgente',
                    component: DatosAgente
                },{
                    path: 'documentos-transporte',
                    name: 'GestionDocumentos',
                    component: GestionDocumentos
                },{
                    path: 'tracking',
                    name: 'Tracking',
                    component: Tracking
                },{
                    path: 'tracking-local',
                    name: 'TrackingLocal',
                    component: TrackingLocal
                },{
                    path: 'datos-personal',
                    name: 'DatosPersonal',
                    component: DatosPersonal
                }
                ,{
                    path: 'gestion-costo-aereo',
                    name: 'GestionCostoAereo',
                    component: GestionCostoAereo
                },{
                    path: 'gestion-costo-terrestre',
                    name: 'GestionCostoTerrestre',
                    component: GestionCostoTerrestre
                },{
                    path: 'gestion-costo-terrestre-exclusivo',
                    name: 'GestionCostoExclusivo',
                    component: GestionCostoExclusivo
                }
                ,{
                    path: 'gestion-metodo-envio',
                    name: 'GestionMetodoEnvio',
                    component: GestionMetodoEnvio
                },{  
                    path: 'gestion-tipos-unidades',
                    name: 'GestionTiposUnidades',
                    component: GestionTiposUnidades
                },{  
                    path: 'gestion-vehiculos',
                    name: 'GestionVehiculos',
                    component: GestionVehiculos
                },{  
                    path: 'gestion-usuarios',
                    name: 'GestionUsuarios',
                    component: GestionUsuarios
                },{
                    // Solo admin: el API responde 403 a cualquier otro cargo
                    path: 'auditoria',
                    name: 'Auditoria',
                    component: Auditoria
                }
            ],
            beforeEnter: (to, from, next) => {
                const token = localStorage.getItem('token');
                if (token) {
                    next(); // Si hay token, continua
                } else {
                    next('/login'); // Si no hay token, redirige al login
                }
            }
        },
        { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
    ]
});
